import React from 'react';

const Coming = () => {
    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-br from-gray-900 to-black p-4">
        <div className="bg-gradient-to-r from-gray-800 to-gray-900 p-6 rounded-2xl shadow-xl w-full max-w-md text-white">
            <h1 className="text-3xl font-bold text-center mb-4 text-indigo-400">Coming Soon</h1>
            <p className="text-center text-gray-400 mb-6">This feature is coming soon</p>
        </div>
        </div>
    );
    }

export default Coming;